import React from 'react';
import type { ShowcasePopulatedItem } from 'root/apiTypes';
import { Item } from 'root/components/Menus/Item/Item';
import { classes, st } from './Items.st.css';
import { dataHooks } from 'root/dataHooks';
import { ItemsContextProvider } from 'root/contexts/ItemsContext';
import { DesignedDivider } from 'root/components/Menus/DesignedDivider/DesignedDivider';

export const Items = ({
  isSectionCollapsed = false,
  items,
  sectionId,
  sectionTitleId,
}: {
  items: ShowcasePopulatedItem[];
  sectionId: string;
  sectionTitleId: string;
  isSectionCollapsed?: boolean;
}) => {
  return (
    <ItemsContextProvider value={{ sectionId }}>
      <div
        aria-labelledby={sectionTitleId}
        className={st(classes.itemsContainer, isSectionCollapsed ? classes.collapse : '')}
        data-hook={dataHooks.items.container}
        role="list"
      >
        {items.map((item) => (
          <>
            <div className={classes.dividerContainer} role="listitem">
              <DesignedDivider className={classes.divider} dividerName="itemDivider" />
            </div>
            <Item key={item.id} item={item} />
          </>
        ))}
      </div>
    </ItemsContextProvider>
  );
};
